import React, { useState } from 'react';
import { useOutletContext, useNavigate } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import PortalIFrame from 'components/shared/PortalIFrame';
import DataRetentionSettings from 'components/user/DataRetentionSettings';

const CompanySettings = () => {
    const { companyId } = useOutletContext();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [tab, setTab] = useState(0);

    return (
        <Box>
            <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tab label={t('companyPage.settings.tabs.transcription')} sx={{ textTransform: 'none' }} />
                <Tab label={t('companyPage.settings.tabs.dataRetention')} sx={{ textTransform: 'none' }} />
            </Tabs>

            {tab === 0 && (
                <PortalIFrame
                    id='companySettingsIframe'
                    relativeUrl={`/x/${companyId}/TranscriptionSettings`}
                    onDashboardRedirect={() => navigate('../projects')}
                />
            )}

            {tab === 1 && (
                <Box sx={{ pt: 2, pb: 4, maxWidth: 480 }}>
                    <DataRetentionSettings companyId={companyId} />
                </Box>
            )}
        </Box>
    );
};

export default CompanySettings;
